import React from 'react';
import { Link } from 'gatsby';
import classnames from 'classnames';

import './TutorialPage.scss';
import { PageProps } from '../../entities/ContentProps';

export default function Page({ className, children }: PageProps) {
  return (
    <div className={classnames('page-link', className)}>
      <Link to={children.node.fields.slug}>
        <div className="page-link__box">
          <div className={classnames('page-link__info', { 'page-link__info--only-date': !children.node.childMdx.frontmatter.difficulty })}>
            {children.node.childMdx.frontmatter.difficulty && (
              <span
                className={classnames('page-link__label', {
                  'page-link__label--advanced': children.node.childMdx.frontmatter.difficulty === 'advanced',
                  'page-link__label--intermediate': children.node.childMdx.frontmatter.difficulty === 'intermediate',
                })}
              >
                {children.node.childMdx.frontmatter.difficulty}
              </span>
            )}
          </div>
          <h4>{children.node.childMdx.frontmatter.title}</h4>
          <p>{children.node.childMdx.frontmatter.description}</p>
        </div>
      </Link>
    </div>
  );
}
